import { AxiosRequestConfig } from 'axios';
import client from '../client';

/** GET /api/notifications — optional params: application_id, notification_category, related_user_id */
export function get(customConfig?: AxiosRequestConfig) {
    const url = `/notifications`;
    return client.get(url, customConfig);
}

/** GET /api/notifications/unread → { is_unread: boolean } */
export function getUnread(customConfig?: AxiosRequestConfig) {
    const url = `/notifications/unread`;
    return client.get(url, customConfig);
}

/** GET /api/notifications/<user_id> — client notifications for an admin-linked candidate */
export function getNotificationsForClient(
    clientId: string | number,
    customConfig?: AxiosRequestConfig
) {
    const url = `/notifications/${clientId}`;
    return client.get(url, customConfig);
}

/** DELETE /api/notification?notification_id= */
export function deleteNotification(notificationId: string | number) {
    const url = `/notification?notification_id=${notificationId}`;
    return client.delete(url);
}

/** GET /api/notifications/categories */
export function getNotificationTypes() {
    const url = `/notifications/categories`;
    return client.get(url);
}
